// @flow
import { consts as uploaderConsts } from "uploader";
import { asAbsolute } from "./utils";

type NavItem = {id: string, path: string, title: string};

const SRCS = uploaderConsts.SOURCES;

const navItems: NavItem[] = [{
	id: SRCS.LOCAL,
	path: asAbsolute(SRCS.LOCAL),
	title: "menu.files",
}, {
	id: SRCS.URL,
	path: asAbsolute(SRCS.URL),
	title: "menu.web",
}, {
	id: SRCS.CAMERA,
	path: asAbsolute(SRCS.CAMERA),
	title: "menu.camera",
}, {
	id: SRCS.IMAGE_SEARCH,
	path: asAbsolute(SRCS.IMAGE_SEARCH),
	title: "menu.gsearch",
}, {
	id: SRCS.GOOGLE_DRIVE,
	path: asAbsolute(SRCS.GOOGLE_DRIVE),
	title: "menu.gdrive",
}, {
	id: SRCS.DROPBOX,
	path: asAbsolute(SRCS.DROPBOX),
	title: "menu.dropbox",
}, {
	id: SRCS.FACEBOOK,
	path: asAbsolute(SRCS.FACEBOOK),
	title: "menu.facebook",
}, {
	id: SRCS.INSTAGRAM,
	path: asAbsolute(SRCS.INSTAGRAM),
	title: "menu.instagram",
}, {
	id: SRCS.SHUTTERSTOCK,
	path: asAbsolute(SRCS.SHUTTERSTOCK),
	title: "menu.shutterstock",
}, {
	id: SRCS.ISTOCK,
	path: asAbsolute(SRCS.ISTOCK),
	title: "menu.istock",
}, {
	id: SRCS.UNSPLASH,
	path: asAbsolute(SRCS.UNSPLASH),
	title: "menu.unsplash",
}];

export default navItems;
